import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { CashBookingService } from './services/cashbooking.service';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule) },
  {
    path:'',
    loadChildren:()=>import('../app/views/layout/layout.module').then(m=>m.LayoutModule)
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    // children: [
    //   {
    //     path: 'home',
    //     // loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
    //     loadChildren: () => import('./views/pages/realtimetracking/realtimetracking.module').then(m=> m.RealTimeTrackingModule)
    //   },
    //   {
    //     path: 'dashboard',
    //     // loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
    //      loadChildren: () => import('./views/pages/realtimetracking/realtimetracking.module').then(m=> m.RealTimeTrackingModule)
    //   },
    //   // {
    //   //   path: 'dashboard/:id',
    //   //   loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
    //   // },
    //   { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

    //   {
    //     path: 'realtimetracking',
    //     loadChildren: () => import('./views/pages/realtimetracking/realtimetracking.module').then(m=> m.RealTimeTrackingModule)
    //   },
      
    //   {
    //     path: 'users',
    //     loadChildren: () => import('./views/pages/master/user/user.module').then(m => m.UserModule)
    //   },
    //   {
    //     path: 'devices',
    //     loadChildren: () => import('./views/pages/master/device/device.module').then(m => m.DeviceModule)
    //   },
    //   {
    //     path: 'providers',
    //     loadChildren: () => import('./views/pages/master/provider/provider.module').then(m => m.ProviderModule)
    //   },
    //   {
    //     path: 'drivers',
    //     loadChildren: () => import('./views/pages/master/driver/driver.module').then(m => m.DriverModule)
    //   },
    //   {
    //     path: 'serviceschedules',
    //     loadChildren: () => import('./views/pages/master/serviceschedule/serviceschedule.module').then(m => m.ServicescheduleModule)
    //   },
    //   {
    //     path: 'livetrack',
    //     loadChildren: () => import('./views/pages/tracking/livetrack/livetrack.module').then(m => m.LivetrackModule)
    //   },
    //   {
    //     path: 'livetrack/:id',
    //     loadChildren: () => import('./views/pages/tracking/livetrack/livetrack.module').then(m => m.LivetrackModule)
    //   },
    //   {
    //     path: 'realtimecharts',
    //     loadChildren: () => import('./views/pages/realtimetracking_charts/realtimetracking_charts.module').then(m => m.RealtimetrackingChartsModule)
    //   },
    //   {
    //     path: 'evaadagaidashboard',
    //     loadChildren: () => import('./views/pages/mhire/mhiredashboard/mhiredashboard.module').then(m => m.MhiredashboardChartsModule)
    //   },
    //   {
    //     path: 'realtimecharts/:id',
    //     loadChildren: () => import('./views/pages/realtimetracking_charts/realtimetracking_charts.module').then(m => m.RealtimetrackingChartsModule)
    //   },
    //   {
    //     path: 'vehiclegroups',
    //     loadChildren: () => import('./views/pages/master/vehiclegroup/vehiclegroup.module').then(m => m.VehiclegroupModule)
    //   },
    //   {
    //     path: 'vehicles',
    //     loadChildren: () => import('./views/pages/master/vehicle/vehicle.module').then(m => m.VehicleModule)
    //   },
    //   {
    //     path: 'fuellog',
    //     loadChildren: () => import('./views/pages/rollcall/fuellog/fuellog.module').then(m => m.FuelLogModule)
    //   },
    //   {
    //     path: 'farmerentries',
    //     loadChildren: () => import('./views/pages/rollcall/farmer/farmer.module').then(m => m.FarmerModule)
    //   },
    //   {
    //     path: 'servicelog',
    //     loadChildren: () => import('./views/pages/rollcall/servicelog/servicelog.module').then(m => m.ServiceLogModule)
    //   },
    //   {
    //     path: 'triplog',
    //     loadChildren: () => import('./views/pages/rollcall/triplog/triplog.module').then(m => m.TripLogModule)
    //   },
    //   {
    //     path: 'profile/:id/:actionInfo',
    //     loadChildren: () => import('./views/pages/profile/profile/profile.module').then(m => m.ProfileModule)
    //   },
    //   {
    //     path: 'tripreport',
    //     loadChildren: () => import('./views/pages/reports/tripreport/tripreport.module').then(m => m.TripReportModule)
    //   },
    //   {
    //     path: 'dailyreport',
    //     loadChildren: () => import('./views/pages/reports/dailyreport/dailyreport.module').then(m => m.DailyReportModule)
    //   },
    //   {
    //     path: 'weeklyreport',
    //     loadChildren: () => import('./views/pages/reports/weeklyreport/weeklyreport.module').then(m => m.WeeklyReportModule)
    //   },
    //   {
    //     path: 'monthlyreport',
    //     loadChildren: () => import('./views/pages/reports/monthlyreport/monthlyreport.module').then(m => m.MonthlyReportModule)
    //   },
    //   {
    //     path: 'outturnreport',
    //     loadChildren: () => import('./views/pages/reports/outturnreport/outturnreport.module').then(m => m.OutturnReportModule)
    //   },
    //   {
    //     path: 'stoppagetruckreport',
    //     // tslint:disable-next-line: max-line-length
    //     loadChildren: () => import('./views/pages/reports/stoppagetruckreport/stoppagetruckreport.module').then(m => m.StoppagetruckreportModule)
    //   },
    //   {
    //     path: 'tripsimulationreport',
    //     // tslint:disable-next-line: max-line-length
    //     loadChildren: () => import('./views/pages/reports/tripsimulationreport/tripsimulationreport.module').then(m=> m.TripsimulationModule)
    //   },
    //   {
    //     path: 'regions',
    //     loadChildren: () => import('./views/pages/master/region/region.module').then(m=> m.RegionModule)
    //   },
    //   {
    //     path: 'divisions',
    //     loadChildren: () => import('./views/pages/master/division/division.module').then(m=> m.DivisionModule)
    //   },
    //   {
    //     path: 'subdivisions',
    //     loadChildren: () => import('./views/pages/master/subdivision/subdivision.module').then(m=> m.SubDivisionModule)
    //   },
    //   {
    //     path: 'workshops',
    //     loadChildren: () => import('./views/pages/master/workshop/workshop.module').then(m=> m.WorkshopModule)
    //   },

    //   {
    //     path: 'implements',
    //     loadChildren: () => import('./views/pages/master/implements/implement.module').then(m=> m.ImplementModule)
    //   },
    //   {
    //     path: 'tariffs',
    //     loadChildren: () => import('./views/pages/master/tarrif/tarrif.module').then(m=> m.TarrifModule)
    //   },
    //   {
    //     path: 'tripentries',
    //     loadChildren: () => import('./views/pages/rollcall/tripentry/tripentry.module').then(m=> m.TripEntryModule)
    //   },
    //   {
    //     path: 'targets',
    //     loadChildren: () => import('./views/pages/master/target/target.module').then(m=>m.TargetModule)
    //   },
    //   {
    //     path: 'expenselogs',
    //     loadChildren: () => import('./views/pages/master/expense/expense.module').then(m=> m.ExpenseModule)
    //   },
    //   {
    //     path: 'consumables',
    //     loadChildren: () => import('./views/pages/master/consumable/consumable.module').then(m=> m.ConsumableModule)
    //   },
    //   {
    //     path: 'cashbooking',
    //     loadChildren: () => import('./views/pages/mhire/cashbooking/cashbookingentry.module').then(m=> m.CashbookingModule)
    //   }
    //   ,
    //   {
    //     path: 'consumableentries',
    //     loadChildren: () => import('./views/pages/rollcall/consumableentry/consumableentry.module').then(m=> m.ConsumableentryModule)
    //   },
    //   {Routing
    //     path: 'expenseentries',
    //     loadChildren: () => import('./views/pages/rollcall/expenseentry/expenseentry.module').then(m=> m.ExpenseentryModule)
    //   },
    //   {
    //     path: 'makes',
    //     loadChildren: () => import('./views/pages/master/make/make.module').then(m=> m.MakeModule)
    //   },
    //   {
    //     path: 'models',
    //     loadChildren: () => import('./views/pages/master/model/model.module').then(m=>m.ModelModule)
    //   },
    //   {
    //     path: 'homeconnect',
    //     loadChildren: () => import('./views/pages/master/homeconnect/homeconnect.module').then(m=> m.HomeconnectModule)
    //   },
    //   {
    //     path:'quickrollcallentry',
    //     loadChildren: () => import('./views/pages/rollcall/quickentry/quickentry.module').then(m=> m.QuickentryModule)
    //   },
    //   {
    //     path:'quickrollcallentry/:id',
    //     loadChildren: () => import('./views/pages/rollcall/quickentry/quickentry.module').then(m=> m.QuickentryModule)
    //   },
    //   {
    //     path: 'machineryallocate',
    //     loadChildren: () => import('./views/pages/mhire/machineryallocate/machineryallocate.module').then(m=> m.MachineryallocateModule)
    //   },
    //   {
    //     path: 'oldlogbook',
    //     loadChildren: () => import('./views/pages/mhire/oldlogbook/logbook.module').then(m=> m.LogbookModule)
    //   },
    //   {
    //     path: 'mhirelogbook',
    //     loadChildren: () => import('./views/pages/mhire/mhirelogbook/mhirelogbook.module').then(m=> m.MhirelogbookModule)
    //   },
    //   {
    //     path: 'bookingreport',
    //     loadChildren: () => import('./views/pages/reports/bookingreport/bookingreport.module').then(m => m.BookingReportModule)
    //   },
    //   {
    //     path: 'refundapproval',
    //     loadChildren: () => import('./views/pages/mhire/refundapproval/refundapproval.module').then(m=> m.RefundapprovalModule)
    //   },
    //   {
    //     path: 'onlinereceipts',
    //     loadChildren: () => import('./views/pages/mhire_accounts/settlement/settlement.module').then(m=> m.SettlementModule)
    //   },
    //   {
    //     path: 'cashreceipts',
    //     loadChildren: () => import('./views/pages/mhire_accounts/poolaccounttransfer/poolaccounttransfer.module').then(m=> m.PoolaccounttransferModule)
    //   },
    //   {
    //     path: 'treasurytransfer',
    //     loadChildren: () => import('./views/pages/mhire_accounts/treasurytransfer/treasurytransfer.module').then(m=> m.TreasurytransferModule)
    //   },
    //   {
    //     path: 'departmentbooking',
    //     loadChildren: () => import('./views/pages/mhire/departmentbooking/departmentbooking.module').then(m=> m.DepartmentbookingModule)
    //   },
    //   {
    //     path: 'mhiredemo',
    //     loadChildren: () => import('./views/pages/mhire/mhiredemo/mhiredemo.module').then(m=> m.MhiredemoModule)
    //   },
    //   {
    //     path: 'scheme',
    //     loadChildren: () => import('./views/pages/mhire/scheme/scheme.module').then(m=> m.SchemeModule)
    //   },
    //   {
    //     path: 'news',
    //     loadChildren: () => import('./views/pages/mhire/news/news.module').then(m=> m.NewsModule)
    //   },
      
    // ]
  },
  {
    path: 'product/:id',
    loadChildren: () => import('./views/pages/dbt/product/product.module').then(m => m.ProductModule)
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: 'Page Not Found',
      desc: 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },

  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
  providers:[CashBookingService]
})
export class AppRoutingModule { }
